<div class="item-wrapper">
  <div class="flag-label-wrapper">
    <div class="iti-flag {{msisdn.isoCountry || msisdn.countryCode | lowercase}}"></div>
    <span class="text-ellipsis">{{msisdn.label}}</span>
  </div>
  <span class="msisdn">{{msisdn.msisdn}}</span>
</div>
